import { useState, useEffect, useCallback } from "react";
import axios from "axios";
import SelectorCursosActivos from "./SelectorCursosActivos";
import SelectorCategoriasCursos from "./SelectorCategoriasCursos";
import Swal from "sweetalert2";
import ObtieneDatosCookies from "../obtieneDatosCookiesUsuario";
import DescargarAusenciasEscuela from "./DescargarAusenciasEscuela";
import comprueboPermisos from "../tools/comprueboPermisos";


const GestorAlumnos = () => {
  
  const [selected, setSelected] = useState([]);
const Usuario=ObtieneDatosCookies()

const tocame=async()=>{try {
    const res = await axios.post(
      "https://wwwa.isepsantafe.net.ar/expedientes/resumenAsignacionesPorEscuela",
      
    );

//     console.log("Respuesta:", res.data);
  } catch (err) {
    console.error(
      "Error:",
      err.response?.data || err.message
    );
  }
  
}
  
const accederPlataforma = async ( ) => {
    try {

      const response = await axios.post(
        "https://wwwa.isepsantafe.net.ar/expedientes/sso-moodle",
        {
          dni: Usuario.identificacion,
          plataformaUrl:"https://cursos.isepsantafe.net.ar/"
        }
      );

      const { redirectUrl } = response.data;

      window.open(redirectUrl, "_blank");

    } catch (error) {
      // ⛔ NO console.error(error)

      const status = error.response?.status;
      const mensaje =
        error.response?.data?.message ||
        "No fue posible acceder a la plataforma";

      Swal.fire({
        icon: status === 403 ? "info" : "error",
        title:
          status === 403
            ? "No estas matriculado!!"
            : "Error de acceso",
        text: mensaje,
        confirmButtonText: "Aceptar"
      });
    }
  };

  return (
   <>
   <div style={{textAlign:"center"}}>
 <button className="btn btn-success"onClick={()=>accederPlataforma()}>Ingresar a la plataforma</button>
 {
  comprueboPermisos(Usuario.funcion,"Descargo Inasistencias Escuela")?<> <DescargarAusenciasEscuela/></>:""
 }

  <h2>Gestión de Alumnos de Cursos Activos</h2>
      <SelectorCursosActivos />
   </div>
  
    
 
     
  

</>
  );
};

export default GestorAlumnos;
